import React, { useEffect, useState } from 'react'
import MainLayout from '../../containers/MainLayout'
import { Link } from 'react-router-dom'
import { getURLByRouteName } from '../../utils/routes'
import SanferRedLabel from '../../baseComponents/SanferRedLabel'
import PageTitle from '../../baseComponents/PageTitle'
import Loader from '../../baseComponents/Loader'


import arrow from '../../assets/images/svg_icons/arrow.svg'
import titleLogo from '../../assets/images/title-icons/Internet-Line.svg'

import { getPosts } from '../../services/blog'
import { connect } from 'react-redux'
import { langTexts } from './locals'

import './index.css'

const Blog = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  const [isFetching, setIsFetching] = useState(true)
    , [data, setData] = useState(null)
    , [activeClass, setActiveClass] = useState('')

  useEffect(() => {
    let timeout = null
    getPosts()
      .then(res => {
        setData(res)
        // setIsFetching(false)
        timeout = setTimeout(() => {
          setIsFetching(false)
          setActiveClass('active')
        }, 2000)
      })
      .catch(err => console.log(err))
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  if (isFetching) return <Loader />

  let info = data[lang].blog

  let postColumnOne = []
    , postColumnTwo = []
    , postColumnThree = []

  let blocks = []
    , subBlock = []
  for (let index = 1; index < info.posts.length; index++) {
    subBlock.push(info.posts[index])
    if (index % 6 === 0) {
      blocks.push(subBlock)
      subBlock = []
    }
  }
  if (subBlock.length !== 5) blocks.push(subBlock)

  for (let index = 0; index < blocks.length; index++) {
    let blockOne = [], blockTwo = [], blockThree = null
      , currentBlock = blocks[index]
    blockOne = currentBlock.filter((_, i) => i < 2)
    blockTwo = currentBlock.filter((_, i) => i > 1 && i < 5)
    blockThree = currentBlock[5] ? blocks[index][5] : null

    postColumnOne = [...postColumnOne, ...blockOne]
    postColumnTwo = [...postColumnTwo, ...blockTwo]
    if (blockThree) postColumnThree.push(blockThree)
  }

  let featured = info.posts[0]

  return <MainLayout id='blog' className={`${activeClass} transition`} redLabel={false}>
    <SanferRedLabel />
    <PageTitle title={"Blog"} label={"comprometidos con tu salud"} logo={titleLogo} />
    <div className='home__blog-paragraphs gray-color' style={{ width: '50%' }} dangerouslySetInnerHTML={{ __html: "<p>El mundo cambia día con día y la medicina también.Mantente al tanto de los temas más relevantes de salud.</p>" }} />

    <div className='home__blog-featured'>
      <div className='home__blog-featured-cover' style={{ background: `url(${featured.cover})` }} >
        <div className='decorative top' />
        <div className='vertical'>
          <div className='decorative-vertical left' />
          <div className='decorative-vertical right' />
        </div>
        <div className='decorative bottom' />
      </div>
      <div className='home__blog-featured-content'>
        <SanferRedLabel text={texts.featured} />
        <div className='flex-row'>
          <div className='flex-row opacity-0'>
            <div className='gray-line' />
            <img src={titleLogo} alt={featured.title} />
          </div>
          <div className='home__blog-featured-block'>
            <h2>{featured.title}</h2>
            <p>{featured.extract}</p>
            <div className='gray-line' />
            <Link to={`${getURLByRouteName('blog')}/${featured.slug}`} className='white-color'>
              {texts.knowMore}
              <img className='arrow-left' src={arrow} alt='flecha' />
            </Link>
          </div>
        </div>
      </div>
    </div>

    <div className='home__blog-grid'>
      <div className='home__blog-column column-1'>
        {postColumnOne.map((post, index) => <BlogItem key={index} {...post} texts={texts} />)}
      </div>
      <div className='home__blog-column column-2'>
        {postColumnTwo.map((post, index) => <BlogItem key={index} {...post} texts={texts} />)}
      </div>
      <div className='home__blog-column column-3'>
        {postColumnThree.map((post, index) => <BlogItem key={index} {...post} texts={texts} />)}
      </div>
    </div>
  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(Blog)


const BlogItem = props => {
  const { texts } = props
  return <div className='home__blog-item'>
    <div className='home__blog-item-cover' style={{ background: `url(${props.cover})` }} />
    <div>
      <h2>{props.title}</h2>
      <Link to={`${getURLByRouteName('blog')}/${props.slug}`}>
        {texts.knowMore}
        <img className='arrow-left' src={arrow} alt='flecha' />
      </Link>
    </div>
  </div>
}